import { KnBrQuoteEntryService } from 'src/app/store/kn-br-quote-entry/kn-br-quote-entry.service';
import { KnBrCommonService } from 'src/app/services/kn-br-common.service';
import { KnBrDraftOrdersService } from 'src/app/store/kn-br-draft-orders/kn-br-draft-orders.service';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  ViewContainerRef,
} from '@angular/core';
import { UntypedFormBuilder, ReactiveFormsModule } from '@angular/forms';
import { Observable, Subscription } from 'rxjs';
import { KnBrAddProductsComponent } from 'src/app/kn-br-customer360/kn-br-order-detail/kn-br-add-products/kn-br-add-products.component';
import { KnBrCartContextService } from 'src/app/store/kn-br-cart-context/kn-br-cart-context.service';
import { KnBrOrderHistoryService } from 'src/app/store/kn-br-order-history/kn-br-order-history.service';
import { KnBrQuoteContextService } from 'src/app/store/kn-br-quote-context/kn-br-quote-context.service';
import { KnBrQuotesService } from 'src/app/store/kn-br-quotes/kn-br-quotes.service';
import { ActiveCartService } from '@spartacus/cart/base/core';
import { map, startWith } from 'rxjs/operators';
import { KnBrCustomerContextService } from 'src/app/store/kn-br-customer-context/kn-br-customer-context.service';
import { LaunchDialogService } from '@spartacus/storefront';
import { KnBrAddToCartComponent } from '../../kn-br-product/kn-br-add-to-cart/kn-br-add-to-cart.component';
import { KnBrAddToQuoteComponent } from '../../kn-br-product/kn-br-add-to-quote/kn-br-add-to-quote.component';
import { NgClass, AsyncPipe } from '@angular/common';
import { KnBrNumbersOnlyDirective } from '../../shared/directive/kn-br-numbers-only.directive';
import { TranslatePipe } from '@spartacus/core';

@Component({
    selector: 'knbr-kn-br-quick-entry',
    templateUrl: './kn-br-quick-entry.component.html',
    styleUrls: ['./kn-br-quick-entry.component.scss'],
    changeDetection: ChangeDetectionStrategy.Default,
    imports: [KnBrAddToCartComponent, KnBrAddToQuoteComponent, ReactiveFormsModule, NgClass, KnBrNumbersOnlyDirective, AsyncPipe, TranslatePipe]
})
export class KnBrQuickEntryComponent extends KnBrAddProductsComponent implements OnInit, OnDestroy {
  subscription = new Subscription();
  cartContext: string;
  quoteContext: string;
  customerContext: string;

  quoteItems$: Observable<number> = this.knBrQuoteService.get$.pipe(
    startWith({ totalItems: 0 }),
    map((quote) => (quote && quote.totalItems) || 0)
  );
  cartItems$: Observable<number> = this.activeCartService.getActive().pipe(
    startWith({ totalItems: 0 }),
    map((cart) => (cart && cart.totalItems) || 0)
  );

  constructor(
    protected formBuilder: UntypedFormBuilder,
    protected cdr: ChangeDetectorRef,
    protected knBrOrderHistoryService: KnBrOrderHistoryService,
    protected knBrCartContextService: KnBrCartContextService,
    protected knBrQuoteContextService: KnBrQuoteContextService,
    protected knBrDraftOrdersService: KnBrDraftOrdersService,
    protected knbrCommonService: KnBrCommonService,
    protected activeCartService: ActiveCartService,
    protected knBrQuoteService: KnBrQuotesService,
    protected knBrCustomerContextService: KnBrCustomerContextService,
    protected launchDialogService: LaunchDialogService,
    protected vcr: ViewContainerRef,
    protected knBrQuoteEntryService: KnBrQuoteEntryService
  ) {
    super(
      formBuilder,
      cdr,
      knBrOrderHistoryService,
      knBrDraftOrdersService,
      knbrCommonService,
      launchDialogService,
      vcr,
      knBrQuoteEntryService
    );
    this.subscription.add(
      this.knBrCartContextService.get$.subscribe((data) => {
        this.cartContext = data;
        this.cdr.markForCheck();
      })
    );
    this.subscription.add(
      this.knBrQuoteContextService.get$.subscribe((data) => {
        this.quoteContext = data;
        this.cdr.markForCheck();
      })
    );
    this.subscription.add(
      this.knBrCustomerContextService.getActiveCustomerNumber().subscribe((response) => {
        this.customerContext = response ? response : null;
      })
    );
  }

  ngOnInit() {
    super.ngOnInit();
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }
}
